<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="grid-margin column mobile-full third">
                        <h4>{{ 'paypal_email' | localise }}</h4>

                        <input
                                type="text"
                                class="ref-link"
                                placeholder="{{ 'enter_paypal_email_here' | localise }}"
                                [(ngModel)]="paypal_email"
                        />

                        <select (change)="onCountryChange($event)" class="form-control country">
                            <option
                                    *ngFor="let item of countries"
                                    [selected]="item.locale === selected_country"
                                    [value]="item.locale">
                                {{ item.name }}
                            </option>
                        </select>

                        <div id="social-share">
                            <nav>
                                <a (click)="update()" class="instagram">
                                    <i class="fa fa-pencil"></i>
                                    <span>{{ 'change' | localise }}</span>
                                </a>
                            </nav>
                        </div>
                    </div>
                    <div class="referrals-block grid-margin column mobile-full sixfive-percentage">
                        <h4>{{ 'wallet' | localise }}</h4>

                        <ul class="referrals">
                            <li *ngFor="let transaction of transactions">
                                <button class="time-field btn btn-sm btn-info pull-right">
                                    {{ formatDate(transaction.created_at) }}
                                </button>
                                <p>
                                    {{ transaction.description }}
                                    <span [ngClass]="transaction.type">{{ transaction.money | money }}</span>
                                </p>
                            </li>
                        </ul>

                        <app-alerts-components
                                *ngIf="transactions.length <= 0"
                                [type]="'info'"
                                [disableClose]="true"
                                [icon]="'fa fa-exclamation-triangle'"
                                [id]="'no_transactions'"
                                [title]="'not_found_transactions' | localise"
                                [message]="'not_found_transactions_text' | localise"></app-alerts-components>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
